import { MIN_PASSWORD_LENGTH } from '@/constants/user';

export const getPasswordError = (password: string): string | undefined => {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
  }

  return undefined;
};
